export default "__VITE_ASSET__DoFqc9Bj__"